import { Position, GeolocationOptions } from '../types';

const DEFAULT_GEOLOCATION_OPTIONS: GeolocationOptions = {
  enableHighAccuracy: true,
  timeout: 10000,
  maximumAge: 0,
};

export const POSITION_UPDATE_INTERVAL = 5000; // 5 seconds

export const getCurrentPosition = (
  onSuccess: (position: Position) => void,
  onError?: (error: GeolocationPositionError) => void,
  options: GeolocationOptions = DEFAULT_GEOLOCATION_OPTIONS
): void => {
  if (!navigator.geolocation) {
    console.error('Geolocation is not supported by this browser');
    return;
  }

  navigator.geolocation.getCurrentPosition(
    (position) => {
      const { latitude, longitude } = position.coords;
      onSuccess([latitude, longitude]);
      console.log('Position mise à jour:', latitude, longitude);
    },
    (error) => {
      console.error('Erreur de géolocalisation:', error.message);
      if (onError) {
        onError(error);
      }
    },
    options
  );
};

export const startPositionTracking = (
  onUpdate: (position: Position) => void,
  interval: number = POSITION_UPDATE_INTERVAL
): (() => void) => {
  if (!navigator.geolocation) {
    console.error('La géolocalisation n\'est pas supportée par ce navigateur ou nécessite une connexion HTTPS.');
    alert("Pour que la géolocalisation fonctionne, l'application doit être consultée via HTTPS et vous devez autoriser le partage de votre position.");
    return () => {};
  }

  const watchId = navigator.geolocation.watchPosition(
    (position) => {
      const { latitude, longitude } = position.coords;
      onUpdate([latitude, longitude]);
      console.log('Position (watch) mise à jour:', latitude, longitude);
    },
    (error) => {
      console.error('Erreur de géolocalisation (watch):', error.message);
      // alert("Impossible d'obtenir la position : " + error.message);
    },
    {
      enableHighAccuracy: true,
      timeout: 20000, 
      maximumAge: 5000
    }
  );

  // Return cleanup function
  return () => navigator.geolocation.clearWatch(watchId);
};
